import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PaginationService } from 'src/app/PaginationService';
import { messageService } from 'src/app/message.service';
import { qmsService } from 'src/app/qms/qms.service';
import { DynamicGridConfig, DynamicGridClauses, DynamicGridTrail, DynamicGridReport, DynamicGridSettings } from '../models/dynamic-grid.model';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { EditorComponent } from 'src/app/editor/editor.component';

@Component({
  selector: 'app-dynamic-grid',
  templateUrl: './dynamic-grid.component.html',
  styleUrls: ['./dynamic-grid.component.scss']
})

export class DynamicGridComponent implements OnChanges {

  @Input() config!: DynamicGridConfig;
  @Input() clauses!: DynamicGridClauses;
  @Input() trail!: DynamicGridTrail;
  @Input() report!: DynamicGridReport;
  @Input() settings!: DynamicGridSettings;

  @Output() add = new EventEmitter<any>();
  @Output() edit = new EventEmitter<{ mode: string; id: number, obj: any }>();
  @Output() delete = new EventEmitter<{ obj: any }>();
  @Output() grid_settings = new EventEmitter<any>();
  @Output() reorder = new EventEmitter<{ grid: any }>();
  @Output() refreshed = new EventEmitter<{ grid: any }>();

  auditTrail: any = {};

  constructor(
    readonly router: Router,
    readonly dialog: MatDialog,
    readonly qualityService: qmsService,
    readonly appService: AppService,
    readonly message: messageService,
    readonly paginationService: PaginationService,

    private readonly snackBar: MatSnackBar,
    private readonly elem: ElementRef
  ) { };

  ngOnChanges() {
    [this.grid, this.gridTemp, this.gridObj] = [[], [], {}]; this._refresh();
  }

  grid: any = [];
  gridTemp: any = [];
  gridObj: any = {};
  gridSearchText: any;
  selectedGridData: any = [];
  columnLists: any = {};
  makeStickyColumns: any;
  dataTypeList: any = [];
  parentCheckBox: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];

  private getDynamicGrid(): void {
    this.selectedGridData = [];
    this.parentCheckBox = false;
    const primary_obj: {} = {
      gridName: this.config.gridName,
      groupId: this.config.groupId
    }

    this.appService.getDynamicGridHeaders(primary_obj).subscribe({
      next: (fields: any) => {

        this.makeStickyColumns = fields.fixedFieldCnt;
        const secondary_obj: any = {
          tableOrViewName: fields.tableOrViewName ?? "",
          columnsList: fields.columnsList ?? "",
          fieldLabelsList: fields.fieldLabelsList ?? "",
          invisibleColumn: fields.invisibleColumn ?? "",
          orderByClause: fields.orderByClause ?? "",
          fieldSizeList: fields.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: fields.manualEntryDataFields,
          clobColumnlist: fields.closblist ?? "",
          blobColumnlist: fields.bloblist ?? "",
          ...this.clauses
        }

        this.gridObj = { ...secondary_obj, ...primary_obj };
        this.auditTrail.secondary_obj = secondary_obj;

        this.appService.getDynamicGridData(secondary_obj).subscribe({
          next: (grid: any) => {
            this.grid = grid;
            secondary_obj.columnsListarray = secondary_obj.columnsList.split(",");
            secondary_obj.fieldColumnarray = secondary_obj.fieldLabelsList.split(",");
            secondary_obj.invisibleColumnarray = secondary_obj.invisibleColumn.split(",");
            secondary_obj.fieldSizeListArray = secondary_obj.fieldSizeList.split(",");
            this.columnLists.columnsListarray = secondary_obj.columnsListarray;
            this.columnLists.fieldLabelsList = secondary_obj.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < secondary_obj.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": secondary_obj.fieldColumnarray[p],
                "width": secondary_obj.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = secondary_obj.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of secondary_obj.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }

            this.columnLists.columnsListarray1 = [];
            const x = { tablename: secondary_obj.tableOrViewName };

            this.appService.tableFieldsDataType(x).subscribe((dataType: any) => {
              this.dataTypeList = dataType;

              this.refreshed.emit(this.grid);

              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }

              for (const rowData of this.grid) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType === 'CHECKBOX') {
                    rowData[element.columnName] = rowData[element.columnName] === 'Y';
                  }
                }
              }

              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });

            this.message.gridList = this.grid;
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
          }, error: (error) => {
            throw error;
          }
        });
      }, error: (error) => {
        throw error;
      }
    });
  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetPage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetPage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  columnFilter(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  searchValue2: any;
  globalFilter(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter) {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  columnSort(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  onParentChanged(e: any) {
    if (e.target.checked) {
      this.selectedGridData = this.pagedItems.length == 10 ? this.grid : this.pagedItems;

      for (const element of this.grid) { element.childCheckBox = true }
    } else {

      this.selectedGridData = [];
      for (const element of this.grid) { element.childCheckBox = false }
    }
  }

  onChildChanged(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBox = true;
      this.onChildChecked(list);
    } else {
      this.parentCheckBox = list.childCheckBox = false;
      this.onChildUnchecked(list);
    }
  }

  onChildChecked(checked: any) {
    if (!this.selectedGridData?.some((copied: any) => copied.TEMPLATE_ID === checked.TEMPLATE_ID)) {
      this.selectedGridData.push(checked);
    }

    this.parentCheckBox = this.grid.every((r: any) => r.childCheckBox);
  }

  onChildUnchecked(unchecked: any) {
    this.selectedGridData = this.selectedGridData?.filter((copied: any) => copied.TEMPLATE_ID !== unchecked.TEMPLATE_ID);
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;
  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;

  excelPdf: any = {};

  public _refresh() {
    this.getDynamicGrid();
    this.grid_settings.emit();
  }

  public _add(): void {
    this.add.emit();
  }

  public _edit(action: any, id: any, mode: string): void {
    this.edit.emit({ obj: action, id: id, mode: mode, });
  }

  public _delete(obj: any): void {
    this.delete.emit(obj);
  }

  public _reorder(): void {
    this.reorder.emit({ grid: this.grid });
  }

  public _settings(): void {
    this.gridReorderComponent.reordercall(this.gridObj.gridName, this.gridObj.tableOrViewName, this.settings.module, this.settings.groupId);
  }

  public _trail(viewType: any, trail: any): void {
    this.auditTrail.refNo = viewType == 'overAll' ? null : trail[this.trail.refKey];
    this.auditTrail.viewType = viewType;
    this.auditTrail.activityRefNo = this.trail.activityRefNo;
    this.auditTrail.gridName = this.trail.gridName;
    this.auditTrail.report_And_Popup_Name = this.trail.trailName;
    this.dynamicAuditTrailComponent.triggerTrail({});
  }

  public _report(reportType: string): void {
    this.excelPdf.reportObj = { ...this.gridObj, excludeGroupId: this.report.excludeGroupId };
    this.excelPdf.reportType = this.report.reportType;
    this.excelPdf.reportName = this.report.reportName;
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  public focus(): void { console.log(); }

  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, columnName: any) {
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: columnName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, columnName);
      }, error: (error) => {
        throw error;
      }
    });
  }

}
